// pages/Register.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Turnstile from "../components/Turnstile";

export default function Register() {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    // Turnstile token — null until the widget verifies the user
    const [turnstileToken, setTurnstileToken] = useState(null);

    const { register, user } = useAuth();
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();
        setError("");

        if (!username.trim() || !email.trim() || !password) {
            return setError("All fields are required");
        }
        if (username.trim().length > 30) {
            return setError("Username can not be longer than 30 characters");
        }
        if (password.length < 6) {
            return setError("Password must be at least 6 characters");
        }
        if (password !== confirm) {
            return setError("Passwords do not match");
        }
        if (!turnstileToken) {
            return setError("Please complete the CAPTCHA verification");
        }

        setSubmitting(true);
        try {
            // Pass the Turnstile token as the 4th argument
            await register(username.trim(), email.trim(), password, turnstileToken);
            navigate("/profile");
        } catch (err) {
            setError(err.message || "Registration failed");
        } finally {
            setSubmitting(false);
        }
    }

    if (user) {
        return (
            <div className="wrapper">
                <h1>Register</h1>
                <p>You are already logged in as <strong>{user.username}</strong>.</p>
            </div>
        );
    }

    return (
        <div className="wrapper">
            <h1>Register</h1>

            {error && <p className="error-msg" style={{ color: "red" }}>{error}</p>}

            <form onSubmit={handleSubmit} className="account-form">
                <div className="account-form__input-group">
                    <input
                        className="account-form__input"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Username"
                        autoComplete="username"
                        required
                    />
                    <span className="account-form__icon material-symbols-outlined">person</span>
                </div>
                <div className="account-form__input-group">
                    <input
                        className="account-form__input"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        autoComplete="email"
                        required
                    />
                    <span className="account-form__icon material-symbols-outlined">mail</span>
                </div>
                <div className="account-form__input-group">
                    <input
                        className="account-form__input"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password (min 6 chars)"
                        autoComplete="new-password"
                        required
                    />
                    <span className="account-form__icon material-symbols-outlined">key</span>
                </div>
                <div className="account-form__input-group">
                    <input
                        className="account-form__input"
                        type="password"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        placeholder="Confirm password"
                        autoComplete="new-password"
                        required
                    />
                    <span className="account-form__icon material-symbols-outlined">key</span>
                </div>
                {/* Turnstile CAPTCHA widget */}
                <Turnstile
                    onVerify={(token) => setTurnstileToken(token)}
                    onExpire={() => setTurnstileToken(null)}
                />

                <button type="submit" disabled={submitting || !turnstileToken}>
                    {submitting ? "Creating account…" : "Register"}
                </button>
            </form>

            <p>Already have an account? <Link to="/login">Login</Link></p>
        </div>
    );
}